<script setup lang="ts">
export interface RatingProps {
    rating: number
    max?: number
    classes?: string
}

const props = withDefaults(defineProps<RatingProps>(), {
    max: 5,
    classes: '',
})
const fullStars = ref<number>(0)
const halfStars = ref<number>(0)
const emptyStars = ref<number>(0)

fullStars.value = Math.floor(props.rating)
halfStars.value = Math.ceil(props.rating) - fullStars.value
emptyStars.value = props.max - fullStars.value - halfStars.value
</script>
<template>
  <div :class="['d-inline-flex gap-3', props.classes]">
    <svg
      v-for="(item, index) in fullStars"
      :key="'full-star' + index"
      class="rating-star"
      width="28"
      height="26"
    >
      <use xlink:href="#star-full" />
    </svg>

    <svg
      v-for="(item, index) in halfStars"
      :key="'half-star' + index"
      class="rating-star"
      width="28"
      height="26"
    >
      <use xlink:href="#star-half" />
    </svg>
    <svg
      v-for="(item, index) in emptyStars"
      :key="'empty-star' + index"
      class="rating-star"
      width="28"
      height="26"
    >
      <use xlink:href="#star-empty" />
    </svg>
  </div>
  <IconsWrapper>
    <IconsSymbolStarFull />
    <IconsSymbolStarHalf />
    <IconsSymbolStarEmpty />
  </IconsWrapper>
</template>

<style>
@import './Rating.vars.scss';
</style>

<style scoped lang="scss">
@import './Rating.scss';
</style>
